import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import type { GetAttachmentUploadUrlsMutation, AttachmentUploadBaseData, GetAttachmentUploadUrlsMutationVariables } from '#/graphql/types';
import { getAttachmentUploadUrls } from '#/graphql/mutations';
import { get } from 'lodash';

const q = gql(getAttachmentUploadUrls);

const useGetAttachmentUploadUrl = () => {
  const [mutation, result] = useMutation<GetAttachmentUploadUrlsMutation, GetAttachmentUploadUrlsMutationVariables>(q);
  const uploadFiles = useCallback(
    async (files: AttachmentUploadBaseData[], tenantId?: string) => {
      const response = await mutation({
        variables: {
          files,
          tenantId,
        },
      });

      const result = get(response, 'data.getAttachmentUploadUrls', undefined);

      // Check if the operation failed on the backend
      if (result && result.status !== 200) {
        const errorMessage = result.errors?.join('\n') || 'Create failed';
        throw new Error(errorMessage);
      }
      return get(result, 'data', undefined);
    },
    [mutation],
  );

  return { getAttachmentUploadUrls: uploadFiles, result };
};

export default useGetAttachmentUploadUrl;
